import React from 'react';
import Link from 'next/link';

export default function PublicFooter() {
  return (
    <footer className="bg-primary text-primary-foreground mt-auto">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2.5">
              <div className="flex flex-col leading-tight">
                <span className="font-bold text-base text-white tracking-tight">
                  MegaOSH Certification (MOC Certification)
                </span>
                <span className="text-[10px] font-medium text-blue-200 tracking-widest uppercase">
                  ISO Certification Body
                </span>
              </div>
            </div>
            <p className="text-sm text-blue-200 leading-relaxed">
              Accredited ISO certification services for quality, environmental,
              health &amp; safety, and management systems across Malaysia.
            </p>
          </div>

          {/* Services */}
          <div className="flex flex-col gap-3">
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider">
              Certification Standards
            </h4>
            <ul className="flex flex-col gap-2">
              {[
                'ISO 9001:2015 — Quality Management',
                'ISO 14001:2015 — Environmental',
                'ISO 45001:2018 — Occupational Safety',
                'ISO 13485:2016 — Medical Devices',
                'ISO 37001 ABMS — Anti-Bribery',
                'ISO 27001:2022 — Information Security',
              ]?.map(item => (
                <li key={`footer-std-${item}`} className="text-sm text-blue-200">
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="flex flex-col gap-3">
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider">
              Contact
            </h4>
            <ul className="flex flex-col gap-2">
              <li className="text-sm text-blue-200">
                info@moccertification.com
              </li>
              <li className="text-sm text-blue-200">+60175484599</li>
              <li className="text-sm text-blue-200">
                Kuala Lumpur, Malaysia
              </li>
            </ul>
            <div className="mt-2">
              <Link
                href="/certificate-search-page"
                className="inline-flex items-center gap-2 bg-accent text-white text-sm font-semibold px-4 py-2 rounded-lg hover:opacity-90 transition-all duration-150"
              >
                Verify a Certificate
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-blue-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-blue-300">
            © 2026 MegaOSH Certification (MOC Certification). All rights reserved.
          </p>
          <Link
            href="/admin-login"
            className="text-xs text-blue-400 hover:text-blue-200 transition-colors"
          >
            Admin Portal
          </Link>
        </div>
      </div>
    </footer>
  );
}